import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Base from '../Base';
import Card from '../../components/elements/Card';
import Title from '../../components/common/Title';
import Icon from '../../components/common/Icon';
import { apiRequest } from '../../utils';
import './MemberHome.css';

/* "My Cases" — the shortlist companies a member is assigned to as juror/coach. Case SCORING is
   coming later; for now this lists the assignments and teases what's next.
   Backend: GET /api/bravos/my-cases. */
const MyCases = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [cases, setCases] = useState(null);

  const load = useCallback(() => {
    apiRequest('GET', '/bravos/my-cases')
      .then((res) => setCases((res && res.cases) || []))
      .catch(() => navigate('/member-home'));
  }, [navigate]);

  useEffect(() => { load(); }, [load]);

  return (
    <Base activeNav="home">
      <Card>
        <div className="bravos-brand">
          <div>
            <Title my="0" className="mt-1">{t('myCases')}</Title>
            <p className="bravos-brand__name">{t('myCasesNote')}</p>
          </div>
          <button type="button" className="bravos-wallet__link bravos-members__back"
                  onClick={() => navigate('/member-home')}>
            <Icon name="angle-left" /> {t('back')}
          </button>
        </div>
      </Card>

      {cases === null ? (
        <Card><span className="auth__spinner" /></Card>
      ) : (
        <Card>
          {cases.length === 0 ? (
            <p className="text-muted mb-0">{t('noCasesYet')}</p>
          ) : (
            cases.map((c) => (
              <div key={c.id} className="bravos-member">
                <div className="bravos-member__row">
                  <span className="bravos-member__body">
                    <span className="bravos-member__name">{c.company_name || t('company')}</span>
                  </span>
                  <span className="bravos-cta__tag">{t(`caseKind_${c.kind}`)}</span>
                </div>
              </div>
            ))
          )}
          <p className="bravos-q__hint mt-3 mb-0">
            <Icon name="clock" className="me-1" /> {t('caseScoringComingSoon')}
          </p>
        </Card>
      )}
    </Base>
  );
};

export default MyCases;
